import { render, staticRenderFns } from "./pos-incident-table.vue?vue&type=template&id=315561fe&scoped=true&"
import script from "./pos-incident-table.ts?vue&type=script&lang=ts&"
export * from "./pos-incident-table.ts?vue&type=script&lang=ts&"
import style0 from "./pos-incident-table.scss?vue&type=style&index=0&id=315561fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315561fe",
  null
  
)

export default component.exports